import React from 'react';
import { ErrorMessage, Field } from 'formik';
import PhoneFieldWithCountryFlag from './Includes/PhoneFieldWithCountryFlag';
import AddressFinderField from './Includes/AddressFinderField';

const DonatePersonalInformation = ({ index, heading, children, setFieldValue, handleChange, values }) => {
  return (
    <fieldset className="form-step">
      <div className="form-step__header form-step__header--step1">
        {
          (index) => (
            <div className="form-step-header__number">{index}</div>
          )
        }
        <div className="form-step-header__title">{heading}</div>
      </div>
      <ul className="form-fields">
        <li className="form-field">
          <label className="required">Full name:</label>
          <Field name="fullName" type="text" id="fullName" autoComplete={"nope"}/>
          <ErrorMessage name="fullName">
            {(msg) => (
              <ul className="validationErrors">
                <li id="fullName-error" className="formValidationError">
                  {msg}
                </li>
              </ul>
            )}
          </ErrorMessage>
        </li>
        <li className="form-field">
          <label className="required">Email:</label>
          <Field
            autoComplete={"nope"}
            name="email"
            type="text"
            id="email"
            onChange={(e) => {
              handleChange(e);
              if (values.level == 'friend') {
                let i;
                for (i = 0; i < values.friendsArray.length; i++) {
                  if (document.getElementById(`friend-${i}-same-email`).checked) {
                    setFieldValue(`friendsArray[${i}][email]`, event.target.value);
                  }
                }
              }
            }}
          />
          <ErrorMessage name="email">
            {(msg) => (
              <ul className="validationErrors">
                <li id="email-error" className="formValidationError">
                  {msg}
                </li>
              </ul>
            )}
          </ErrorMessage>
        </li>
        {/* <li className="form-field"> */}
        {/*  <label className="required">Address:</label> */}
        {/*  <Field name="address" type="text" id="address" placeholder="Start typing address or postcode" /> */}
        {/*  <ErrorMessage name="address"> */}
        {/*    {(msg) => ( */}
        {/*      <ul className="validationErrors"> */}
        {/*        <li id="address-error" className="formValidationError"> */}
        {/*          {msg} */}
        {/*        </li> */}
        {/*      </ul> */}
        {/*    )} */}
        {/*  </ErrorMessage> */}
        {/* </li> */}

        <AddressFinderField name={"address"} setFieldValue={setFieldValue} values={values} handleChange={handleChange}/>

        <li className="form-field">
          <label className="required">Phone:</label>
          <Field name="phone" placeholder="Phone" component={PhoneFieldWithCountryFlag} className="dcform__input--text" autoComplete={"nope"}/>
          <ErrorMessage name="phone">
            {(msg) => (
              <ul className="validationErrors">
                <li id="phone-error" className="formValidationError">
                  {msg}
                </li>
              </ul>
            )}
          </ErrorMessage>
        </li>

        {children}

        {/* <PhoneFieldWithCountryFlag /> */}
        {/* {children} */}
      </ul>
    </fieldset>
  );
};
export default DonatePersonalInformation;
